module.exports = __webpack_public_path__ + "static/img/UY300-1.ba78940.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/UY300/UY300-1.jpg
// module id = M7e/
// module chunks = 51